var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-about-partners__wrapper"},[_c('div',{staticClass:"plugin-about-partners"},[(_vm.title)?_c('div',{staticClass:"plugin-about-partners__title",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_c('div',{staticClass:"plugin-about-partners__items"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }